import AgileDevelopmentIcon from "../icons/agile-development";
import serviceImg from "../images/software-and-apps/service-1-1536x864.png";

const AgileDevelopmentTeam = () => {
  return (
    <div
      className="row align-items-center"
      id="agile-development-teams-on-demand"
    >
      <div className="col-12 col-lg-6 order-2 order-md-1">
        <img src={serviceImg} alt="team-img" className="img-fluid" />
      </div>
      <div className="col-12 col-lg-6 order-1 order-md-2 text-center text-lg-end">
        <AgileDevelopmentIcon />
        <h2 className="fs-56 lh-64 gilroy-bold py-5 text-danger">
          Agile Development Teams On Demand
        </h2>
        <p className="fs-16 text-align-justify">
          Fill the ability hole for your custom program ventures in some weeks.
          With get to to over +170 proactive and social experts, you'll be able
          frame a strong advancement group with frontend, backend, or cloud
          outsourcing program advancement administrations that can help you for
          a long time. In their work, they follow 9 a long time of best custom
          computer program improvement hones we archived, which is able wow you
          within the exceptionally to begin with sprint.
        </p>
      </div>
    </div>
  );
};

export default AgileDevelopmentTeam;
